<template>
  <div>
    <ul>
      <li>
        <router-link :to='link' >{{artist.full_name }} {{artist.last_name}}</router-link>
        <div class='deactivate_btn'>
          <a href='#' class='pri_btn d_btn' @click.prevent='_toggle' >Edit</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['artist'],
  computed: {
    full_name () {
      return this.artist.first_name + ' ' + this.artist.last_name
    },
    link: function () {
      return `/artists/edit/${this.artist.id}`
    }
  },
  components: {
  },
  methods: {
    _toggle () {
      this.editArtist = true
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artists/Artist.vue